import { render } from "./app-vehicle-card.vue?vue&type=template&id=7243b5a2&scoped=true&ts=true"
import script from "./app-vehicle-card.vue?vue&type=script&lang=ts"
export * from "./app-vehicle-card.vue?vue&type=script&lang=ts"

import "./app-vehicle-card.vue?vue&type=style&index=0&id=7243b5a2&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7243b5a2"]])

export default __exports__